export class OrganisationRelationModel {
    public organisationRelationId: string;
    public organisationId: string;
    public organisationRoleCode: string;
} 